module.exports = __webpack_public_path__ + "img/pt.d6b22a0e.jpg";